/* Contact click tracking: publishes email_click / phone_click into Shopify's
   customer-events bus so a Custom Pixel can forward them to GA4.

   Why not gtag() directly: GA4 (G-3XFDEC44F4) is delivered by the Google & YouTube
   channel as an App Pixel, which runs sandboxed. window.gtag does not exist on the
   storefront, so an inline onclick="gtag(...)" would throw and send nothing.

   Delegated on document so it also covers mailto: links that come from rich-text
   metafields (page.faq) and from settings.social_email in the footer, which cannot
   carry a hand-written onclick attribute.

   Consumer side lives in Admin > Settings > Customer events > Custom pixel. */
(function () {
  function track(event) {
    var link = event.target && event.target.closest
      ? event.target.closest('a[href^="mailto:"], a[href^="tel:"]')
      : null;
    if (!link) return;

    var href = link.getAttribute('href') || '';
    var name = href.indexOf('tel:') === 0 ? 'phone_click' : 'email_click';

    if (!window.Shopify || !Shopify.analytics || !Shopify.analytics.publish) return;

    Shopify.analytics.publish(name, {
      link_url: href,
      link_text: (link.textContent || '').trim().slice(0, 100),
      page_location: window.location.href
    });
  }

  /* Capture phase: fires even if a carousel or overlay handler stops propagation. */
  document.addEventListener('click', track, true);
})();
